import React, { useEffect, useState } from 'react'
import {
  CButton,
  CCol,
  CFormInput,
  CFormLabel,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from '@coreui/react'
import { isEmpty } from '../../../utils/helper'
import { CustomDescriptionBox } from '../../../../components'

const ArtistTypeCreateModal = (props) => {
  const { openModal, onCancel, data, addCallback, updateCallback } = props

  const [name, setName] = useState('')
  const [description, setDescription] = useState('')

  const [errorData, setErrorData] = useState({})

  const editFlag = !isEmpty(data)

  useEffect(() => {
    if (!isEmpty(data)) {
      handleEdit()
    }
  }, [])

  const handleEdit = () => {
    setName(data.name)
    setDescription(data.description)
  }

  const handleChange = (event, func) => {
    const { value, name } = event.target
    let temp = errorData
    temp[`${name}`] = ''
    setErrorData({ ...temp })
    func(value)
  }
  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (name.trim().length === 0) {
      isFormValid = false
      temp.name = 'Name Cannot be Empty!'
    }
    setErrorData({ ...temp })
    return isFormValid
  }

  const handleSave = () => {
    if (!validateInfo()) return
    let payload = {}
    payload = {
      name: name,
      description: description,
    }

    editFlag ? updateCallback(payload, data._id) : addCallback(payload)
  }

  return (
    <>
      <CModal size="lg" visible={openModal} alignment="center">
        <CModalHeader className="px-5 py-4">
          <CModalTitle>
            {!editFlag ? `Add` : `Edit`} {`Artist Type`}
          </CModalTitle>
        </CModalHeader>
        <CModalBody className="px-5 py-4">
          <CRow>
            <CCol>
              <CFormLabel>Name*</CFormLabel>
              <CFormInput
                type="text"
                value={name}
                name="name"
                onChange={(e) => handleChange(e, setName)}
              />
              <div className="message-text error-message">
                <p>{errorData.name}</p>
              </div>
            </CCol>
            <CCol>
              <CustomDescriptionBox
                title="Description"
                rows={1}
                value={description}
                onChange={setDescription}
              />
            </CCol>
          </CRow>
        </CModalBody>
        <CModalFooter>
          <CButton className="text-white" color="info" onClick={onCancel}>
            Cancel
          </CButton>
          <CButton className="text-white" color="info" onClick={handleSave}>
            Submit
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default ArtistTypeCreateModal
